import React from "react";
import { toast } from "react-toastify";

export default function DateSelector({
  handleDateChange,
  selectDate,
  setDateSelectorPopup,
  downloadReport,
}) {
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#372F5B] p-4 rounded-lg w-full max-w-md">
        <h2 className="text-white mb-4">Select Date Range</h2>

        <div className="flex justify-between items-center mb-4">
          <label className="w-1/2 mr-2 text-white">From:</label>
          <input
            type="date"
            className="block mt-1 p-2 bg-[#2D2545] text-white w-full"
            name="startDate"
            value={selectDate?.startDate}
            onChange={handleDateChange}
          />
        </div>

        <div className="flex justify-between items-center mb-4">
          <label className="w-1/2 mr-2 text-white">To:</label>
          <input
            type="date"
            className="block mt-1 p-2 bg-[#2D2545] text-white w-full"
            name="endDate"
            value={selectDate?.endDate}
            onChange={handleDateChange}
          />
        </div>

        <button
          className="text-white bg-red-500 px-4 py-2 rounded hover:bg-red-600 focus:outline-none ml-2"
          onClick={() => setDateSelectorPopup(false)}
        >
          Cancel
        </button>
        <button
          className="text-gray-600 bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 focus:outline-none ml-2"
          onClick={() => {
            if (selectDate?.startDate && selectDate?.endDate) {
              downloadReport("number-of-user-sessions", selectDate);
            }
            else{
                toast.error("Please select the dates.")
            }
          }}
        >
          Download Report
        </button>
      </div>
    </div>
  );
}
